export enum FhirXmlNamespace {
    xmlns = 'http://hl7.org/fhir',
}
